import { render } from "./FooterEditor.vue?vue&type=template&id=e4086bac&scoped=true"
import script from "./FooterEditor.vue?vue&type=script&lang=js"
export * from "./FooterEditor.vue?vue&type=script&lang=js"

import "./FooterEditor.vue?vue&type=style&index=0&id=e4086bac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4086bac"]])

export default __exports__